import { faFolder, faList } from '@fortawesome/free-solid-svg-icons'
import en from 'src/constants/en'
import {
  CAMPAIGNS_ROUTE,
  CONTENT_ANALYSIS_ROUTE,
  // CUSTOM_REPORTING_ROUTE,
  HOME_ROUTE,
  PROJECTS_ROUTE,
  INBOX_ANALYSIS_ROUTE,
  KEYWORDS_ROUTE,
  REVIEW_ANALYSIS_ROUTE,
  SETTINGS_ROUTE,
  THREADS_ROUTE,
  AI_LISTENING_BRAND_ROUTE,
  AI_LISTENING_PROMPTS_ROUTE,
  AD_ANALYSIS_LIBRARY_ROUTE,
  AD_ANALYSIS_PERFORMANCE_ROUTE,
} from 'src/constants/routes'
import { ReactComponent as AIListeningIcon } from 'src/assets/svg/ai-Listening.svg'
import { ReactComponent as AdAnalysisIcon } from './icons/Ad-Analysis.svg'
import { ReactComponent as HomeIcon } from './icons/Home.svg'
import { ReactComponent as InboxAnalysisIcon } from './icons/Inbox-Analysis.svg'
import { ReactComponent as ContentAnalysisIconNew } from './icons/Content-Analysis.svg'
// import { ReactComponent as CustomReportingIcon } from './icons/Custom-Reporting.svg'
import { ReactComponent as ReviewAnalysisIcon } from './icons/Review-Analysis.svg'
import { ReactComponent as SettingsIcon } from './icons/Settings.svg'
import { ReactComponent as SocialListeningIcon } from './icons/Social-Listening.svg'

export const SIDEBAR_ITEMS = [
  {
    customIcon: HomeIcon,
    name: 'Home',
    route: HOME_ROUTE,
  },
  {
    icon: faFolder,
    name: 'Projects',
    route: PROJECTS_ROUTE,
  },
  {
    isFeaturesLabel: true,
    name: 'Features',
  },
  {
    customIcon: SocialListeningIcon,
    isGroupLabel: true,
    name: 'Social Listening',
  },
  {
    isNested: true,
    name: en.campaigns,
    route: CAMPAIGNS_ROUTE,
  },
  {
    hasDivider: true,
    isNested: true,
    name: en.keywords,
    route: KEYWORDS_ROUTE,
  },
  {
    customIcon: AIListeningIcon,
    isGroupLabel: true,
    name: 'AI Listening',
  },
  {
    isNested: true,
    name: 'Brand Profile',
    route: AI_LISTENING_BRAND_ROUTE,
  },
  // Action Plan stays hidden until it is designed.
  {
    hasDivider: true,
    isNested: true,
    name: 'Prompts',
    route: AI_LISTENING_PROMPTS_ROUTE,
  },
  {
    customIcon: InboxAnalysisIcon,
    name: 'Inbox Analysis',
    route: INBOX_ANALYSIS_ROUTE,
  },
  {
    customIcon: ContentAnalysisIconNew,
    name: 'Content Analysis',
    route: CONTENT_ANALYSIS_ROUTE,
  },
  {
    customIcon: ReviewAnalysisIcon,
    name: 'Review Analysis',
    route: REVIEW_ANALYSIS_ROUTE,
  },
  {
    customIcon: AdAnalysisIcon,
    isGroupLabel: true,
    name: 'Ad Analysis',
  },
  // Temporarily hidden — the Ad Analysis Overview page is empty while only
  // Ad Library is enabled. Restore once Overview has content.
  // {
  //   isNested: true,
  //   name: 'Overview',
  //   route: AD_ANALYSIS_OVERVIEW_ROUTE,
  // },
  {
    isNested: true,
    name: 'Ad Library',
    route: AD_ANALYSIS_LIBRARY_ROUTE,
  },
  {
    hasDivider: true,
    isNested: true,
    name: 'Ad Performance',
    route: AD_ANALYSIS_PERFORMANCE_ROUTE,
  },
  // {
  //   customIcon: CustomReportingIcon,
  //   name: 'Custom Reporting',
  //   route: CUSTOM_REPORTING_ROUTE,
  // },
  {
    customIcon: SettingsIcon,
    name: en.settings,
    route: SETTINGS_ROUTE,
  },
  {
    icon: faList,
    name: en.threads,
    requiresAdminAccess: true,
    route: THREADS_ROUTE,
  },
]
